/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Create_Public_ThreadsInputs */



/**
* | output |
* | --- |
* | "Create Public Threads" |
*
* @param {Leveling_Perm_Create_Public_ThreadsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_create_public_threads = /** @type {((inputs?: Leveling_Perm_Create_Public_ThreadsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Create_Public_ThreadsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создавать публичные ветки")
	return /** @type {LocalizedString} */ ("Create Public Threads")
});